import Icon from '@klv/atoms/icon';
import { generateClassName } from '@klv/shared/utils/functions';
import type { IHeadlineOnly } from '../types';
import * as styles from '../styles/tile.module.css';

const HeadlineOnly = ({
  backgroundColor,
  headline,
  hoverColor,
  link,
  mainTileHoverColor,
  openInNewTab,
}: IHeadlineOnly) => (
  <div
    className={styles.headlineOnlyContainer}
    data-background-color={backgroundColor}
    data-hover-color={hoverColor || mainTileHoverColor}
  >
    <a
      className={styles.tileLink}
      aria-label={openInNewTab ? `${headline} (opens in a new tab)` : ''}
      href={link}
      target={openInNewTab ? '_blank' : '_self'}
    >
      <div className={styles.contentContainer}>
        {headline && (
          <div
            className={generateClassName([
              styles.headlineOnlyHeadline,
              'h5',
              'semibold',
            ])}
          >
            {headline}
          </div>
        )}
        <Icon fillColor='inherit' size={2.4} iconName='ArrowButtonRight' />
      </div>
    </a>
  </div>
);

export default HeadlineOnly;
